import type { EngagementEvent, EngagementEventType, EngagementOperation } from "@/types/engagement";
import { groupKey, groupLabel, groupDateRange } from "@/utils/dateUtils";

export function buildAction(type: EngagementEventType, operation: EngagementOperation): string {
  const labels: Record<EngagementEventType, string> = {
    note: "Note", activity: "Activity", opportunity: "Opportunity",
    project: "Project", document: "Document", email: "Email", prospect: "Prospect",
  };
  const completedLabel = type === "opportunity" ? "closed" : "completed";
  if (operation === "createdandcompleted") return `${labels[type]} created & ${completedLabel}`;
  if (operation === "completed") return `${labels[type]} ${completedLabel}`;
  return `${labels[type]} ${operation}`;
}

export function buildByLine(type: EngagementEventType, userName: string | null): string | null {
  if (!userName) return null;
  return type === "email" ? `from ${userName}` : `by ${userName}`;
}

export function engagementEventKey(event: EngagementEvent): string {
  return `${event.type}:${event.entityId}:${event.operation}:${event.date}`;
}

export function groupEventsByPeriod(events: EngagementEvent[]): { label: string; from: string; to: string; events: EngagementEvent[] }[] {
  const groups: Map<string, EngagementEvent[]> = new Map();
  for (const event of events) {
    const key = groupKey(event.date);
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key)!.push(event);
  }
  return Array.from(groups.entries()).map(([key, evts]) => ({
    label: groupLabel(key),
    ...groupDateRange(key),
    events: evts,
  }));
}
